import * as React from 'react';
import { cn } from '@/lib/utils';

export type StatusTone = 'success' | 'warning' | 'info' | 'destructive' | 'neutral';

/**
 * Single source of truth for status chips. Tones map to semantic tokens, never
 * raw colour literals, so success/warning/info read consistently in light + dark.
 */
const toneClasses: Record<StatusTone, string> = {
  success: 'bg-success/12 text-success',
  warning: 'bg-warning/15 text-warning',
  info: 'bg-info/12 text-info',
  destructive: 'bg-destructive/12 text-destructive',
  neutral: 'bg-secondary text-secondary-foreground',
};

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
}

const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(
  ({ tone = 'neutral', className, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold',
        toneClasses[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  ),
);
StatusPill.displayName = 'StatusPill';

export { StatusPill };
